<div class="p-2">
  <ul class="mt-4 flex flex-col flex-wrap justify-center gap-4">
    @for (group of getGroupedLabels(); track group.type) {
      @for (item of group.items; let i = $index; track i) {
        <li>
          <div class="flex items-center gap-2">
            <div class="flex items-center gap-2 min-w-0 flex-1">
              <span
                class="block h-4 w-4 rounded-full align-middle flex-shrink-0"
                [style.backgroundColor]="getBackgroundColorForType(group.type)"
              ></span>
              <strong
                class="block truncate"
                [pTooltip]="getTranslatedLabel({ type: group.type, impact: 0 })"
                tooltipPosition="top">
                {{ getTranslatedLabel({ type: group.type, impact: 0 }) }}:
              </strong>
            </div>

            <div class="flex flex-col">
              <li class="flex items-center gap-2 leading-none">
                <span>
                  @if (isPercentage) {
                    {{ getPercentage(getGlobalIndex(item)) | number: "1.0-2" }}%
                    @if (isKilometer) {
                      , {{ getLabelKm(getGlobalIndex(item)) }}
                    }
                  } @else {
                    {{ getLabelTotal(item) }}
                    @if (isKilometer) {
                      , {{ getLabelKm(getGlobalIndex(item)) }}
                    }
                  }
                </span>
              </li>
            </div>
          </div>

          @if (
            group.subcategories &&
            item.type === "onSiteTransportImpact" &&
            overviewMode === "detailed"
          ) {
            <ul class="ml-10 mt-2">
              @for (sub of group.subcategories; let j = $index; track j) {
                <li class="list-disc">
                  {{ getTranslatedLabel(sub) }} :
                  @if (isPercentage) {
                    {{
                      getSubcategoryPercentage(sub, group) | number: "1.0-2"
                    }}%
                  } @else {
                    {{ getLabelTotal(sub) }}
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    }
  </ul>
</div>
